import { createContext, useContext } from 'react';

type TBrandedLpAnalyticsContext = {
  analytics: {
    navigationId: string;
    impressionId: string;
  };
};

const BrandedLPAnalyticsContext = createContext<
  TBrandedLpAnalyticsContext['analytics'] | null
>(null);

export const BrandedLPAnalyticsProvider = ({
  children,
  analytics: { navigationId, impressionId },
}: React.PropsWithChildren<TBrandedLpAnalyticsContext>) => (
  <BrandedLPAnalyticsContext.Provider value={{ navigationId, impressionId }}>
    {children}
  </BrandedLPAnalyticsContext.Provider>
);

export const useBrandedLPAnalytics = () => {
  const analytics = useContext(BrandedLPAnalyticsContext);
  if (analytics == null) {
    throw new Error('Must use in context!');
  }
  return analytics;
};
